export const SENTIMENT_COLORS = {
  positive: "#059669",
  negative: "#DC2626",
  neutral: "#64748B",
  mixed: "#D97706",
};

export const SENTIMENT_BG = {
  positive: "bg-emerald-50 text-emerald-700 border-emerald-200",
  negative: "bg-red-50 text-red-700 border-red-200",
  neutral: "bg-slate-100 text-slate-600 border-slate-200",
  mixed: "bg-amber-50 text-amber-700 border-amber-200",
};

export const POSITION_COLORS = {
  "Supportive": "#059669",
  "Cautiously supportive": "#0D9488",
  "Neutral or observational": "#64748B",
  "Questioning": "#D97706",
  "Concerned": "#EA580C",
  "Critical": "#DC2626",
  "Uncertain": "#94A3B8",
  "Conflicting": "#9333EA",
};

export const POSITION_BG = {
  "Supportive": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "Cautiously supportive": "bg-teal-50 text-teal-700 border-teal-200",
  "Neutral or observational": "bg-slate-100 text-slate-600 border-slate-200",
  "Questioning": "bg-amber-50 text-amber-700 border-amber-200",
  "Concerned": "bg-orange-50 text-orange-700 border-orange-200",
  "Critical": "bg-red-50 text-red-700 border-red-200",
  "Uncertain": "bg-slate-50 text-slate-500 border-slate-200",
  "Conflicting": "bg-purple-50 text-purple-700 border-purple-200",
};

export const MATURITY_BG = {
  "Established consensus": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "Growing consensus": "bg-teal-50 text-teal-700 border-teal-200",
  "Emerging signal": "bg-indigo-50 text-indigo-700 border-indigo-200",
  "Isolated observation": "bg-slate-100 text-slate-600 border-slate-200",
  "Active controversy": "bg-red-50 text-red-700 border-red-200",
  "Evidence gap": "bg-amber-50 text-amber-700 border-amber-200",
  "Declining concern": "bg-sky-50 text-sky-700 border-sky-200",
};

export const STANCE_COLORS = {
  Supportive: "#059669",
  Neutral: "#64748B",
  Challenging: "#E06C6C",
  Conflicting: "#9333EA",
};

export const TIER_BG = {
  High: "bg-teal-50 text-teal-700 border-teal-200",
  Moderate: "bg-indigo-50 text-indigo-700 border-indigo-200",
  Emerging: "bg-amber-50 text-amber-700 border-amber-200",
};

export const SHIFT_META = {
  rising: { label: "Rising", cls: "text-emerald-600" },
  stable: { label: "Stable", cls: "text-slate-500" },
  declining: { label: "Declining", cls: "text-red-500" },
};

export const CHART_COLORS = ["#0D9488", "#4338CA", "#059669", "#D97706", "#DC2626", "#0EA5E9"];

export const ACCESS_CLASS_BG = {
  "Publicly available": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "Licensed or subscription-based": "bg-indigo-50 text-indigo-700 border-indigo-200",
  "Client-provided": "bg-amber-50 text-amber-700 border-amber-200",
  "Primary research": "bg-teal-50 text-teal-700 border-teal-200",
  "MarksMan conference intelligence": "bg-purple-50 text-purple-700 border-purple-200",
  "Internally generated literature review": "bg-sky-50 text-sky-700 border-sky-200",
  "AI-derived interpretation": "bg-rose-50 text-rose-700 border-rose-200",
};

export const FILTER_OPTIONS = {
  geography: ["North America", "Europe", "APAC"],
  specialty: ["Medical Oncology", "Pathology / Molecular Diagnostics", "Radiation Oncology", "Oncology Pharmacy", "Advanced Practice / Nursing"],
  treatment_line: ["1L", "2L", "3L+"],
  segment: ["KOL", "High Prescriber", "Early Adopter", "Skeptic", "Community Voice"],
  setting: ["Academic", "Community"],
  position: ["Supportive", "Cautiously supportive", "Neutral or observational", "Questioning", "Concerned", "Critical", "Uncertain", "Conflicting"],
  access_class: ["Publicly available", "Licensed or subscription-based", "Client-provided", "Primary research", "MarksMan conference intelligence", "Internally generated literature review"],
};
